<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row py-5" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":4,"redirectToDashboard":false,"redirectDirectLink":"https:\/\/geramyan.com\/submit-form"},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
